// src/pages/Home/CommonSections/CallToActionSection.js
import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// Ensure all necessary icons are imported
// Added faDownload for the new button
import { faEnvelope, faNewspaper, faDollarSign, faUserPlus, faSignInAlt, faDownload, faCalendarAlt, faHandshake} from '@fortawesome/free-solid-svg-icons'
import { library } from '@fortawesome/fontawesome-svg-core';
import { Link } from "react-router-dom";
import { useAuth } from '../../../contexts/AuthContext';

import './css/CallToActionSection.css';

library.add(faEnvelope, faNewspaper, faDollarSign, faUserPlus, faSignInAlt, faDownload, faCalendarAlt, faHandshake);

const CallToActionSection = ({ isEnterprise = false }) => {
    const { currentUser } = useAuth();

    // Enterprise CTA - Premium Dark Theme
    if (isEnterprise) {
        return (
            <Container className="cta-section enterprise-cta-section">
                <Row className="justify-content-center">
                    <Col xs={12} md={10} lg={10}>
                        <div className="enterprise-cta-card">
                            {/* Decorative Background Elements */}
                            <div className="cta-glow-orb cta-glow-left"></div>
                            <div className="cta-glow-orb cta-glow-right"></div>
                            <div className="cta-grid-pattern"></div>

                            <div className="enterprise-cta-content">
                                <h3 className="enterprise-cta-headline">
                                    Ready to Deploy <span className="text-gradient">Sovereign AI?</span>
                                </h3>
                                <p className="enterprise-cta-subtext">
                                    Schedule a 30-minute consultation to discuss your organization's needs,
                                    rollout options, and team key management.
                                </p>
                                <div className="enterprise-cta-buttons" role="group" aria-label="Enterprise contact options">
                                    <Button
                                        size="lg"
                                        className="enterprise-cta-primary"
                                        as={Link}
                                        to="/demo"
                                    >
                                        <span className="enterprise-cta-btn-icon" aria-hidden="true">
                                            <FontAwesomeIcon icon={faCalendarAlt} />
                                        </span>
                                        Schedule Consultation
                                    </Button>
                                    <Button
                                        variant="outline-light"
                                        size="lg"
                                        className="enterprise-cta-secondary"
                                        as={Link}
                                        to="/contactus"
                                    >
                                        <span className="enterprise-cta-btn-icon" aria-hidden="true">
                                            <FontAwesomeIcon icon={faEnvelope} />
                                        </span>
                                        Contact Sales
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        );
    }

    // Personal CTA - Original behavior
    return (
        <Container className="cta-section">
            <Row className="justify-content-center">
                <div className="cta-box">
                    <h3 className="display-4-5 gradient-text">
                        Engage with TensorPilot
                    </h3>
                    <p className="subtitle-text mb-5">
                        Join us to unlock more features, connect with other users, and stay updated on the latest AI developments.
                    </p>

                    <Row>
                        {!currentUser && (
                            <>
                                <Col xs={12} md={4}>
                                    <Button
                                        variant="primary"
                                        size="lg"
                                        className="cta-button primary-cta-button"
                                        as={Link}
                                        to="/signup"
                                    >
                                        <FontAwesomeIcon icon={faUserPlus} className="mr-2" />
                                        Sign Up
                                    </Button>
                                </Col>
                                <Col xs={12} md={4}>
                                    <Button
                                        variant="outline-primary"
                                        size="lg"
                                        className="cta-button"
                                        as={Link}
                                        to="/login"
                                    >
                                        <FontAwesomeIcon icon={faSignInAlt} className="mr-2" />
                                        Sign In
                                    </Button>
                                </Col>
                            </>
                        )}
                        <Col xs={12} md={4}>
                            <Button
                                className="cta-button btn-black-download"
                                size="lg"
                                as={Link}
                                to="/download"
                            >
                                <FontAwesomeIcon icon={faDownload} className="mr-2" />
                                Free Download
                            </Button>
                        </Col>
                        <Col xs={12} md={4}>
                            <Button
                                variant="outline-primary"
                                size="lg"
                                className="cta-button"
                                as={Link}
                                to="/blog"
                            >
                                <FontAwesomeIcon icon={faNewspaper} className="mr-2" />
                                Read Blog
                            </Button>
                        </Col>
                        <Col xs={12} md={4}>
                            <Button
                                variant="outline-primary"
                                size="lg"
                                className="cta-button"
                                as={Link}
                                to="/sales"
                            >
                                <FontAwesomeIcon icon={faDollarSign} className="mr-2" />
                                See Pricing
                            </Button>
                        </Col>
                        <Col xs={12} md={4}>
                            <Button
                                variant="outline-primary"
                                size="lg"
                                className="cta-button"
                                as={Link}
                                to="/contactus"
                            >
                                <FontAwesomeIcon icon={faEnvelope} className="mr-2" />
                                Contact Us
                            </Button>
                        </Col>
                    </Row>
                </div>
            </Row>
        </Container>
    );
};

export default CallToActionSection;